<template>
  <div class="modal-mask">
    <div class="modal-wrapper" @click="clickMask">
      <div class="modal-container">
        <div class="inner-header" :class="{ onlybtn: !fetchLocation }">
          <riderInfoBox
            v-if="fetchLocation"
            @refresh="refresh()"
            :refreshing="refreshing"
            :rider="riderInfo"
            :updatedAt="updatedAt"
          />
          <button @click="closeModal">
            <img src="@/assets/img/order/ic_close_big.svg" />
          </button>
        </div>
        <div v-if="!fetchLocation">
          <fetchFail :code="failCode"></fetchFail>
        </div>
        <div v-else>
          <naver-maps
            :mapOptions="mapOptions"
            :initLayers="initLayers"
            @load="onMapLoad"
            class="map"
          >
            <naver-marker
              v-for="(order, index) in pins"
              :lat="parseFloat(order.coords[0])"
              :lng="parseFloat(order.coords[1])"
              :key="index"
              @load="onMarkerLoad"
            >
              <div class="pin-marker" v-if="index === 0">
                <img src="/assets/img/pin_location_black.svg" />
                <span>출발</span>
              </div>
              <div class="pin-marker" v-else-if="index === pins.length - 1">
                <img src="/assets/img/pin_location_black.svg" />
                <span>도착</span>
              </div>
              <div class="pin-marker" v-else>
                <img src="/assets/img/pin_location.svg" />
                <span>경유{{ index }}</span>
              </div>
            </naver-marker>
            <naver-marker
              :lat="parseFloat(mapOptions.lat)"
              :lng="parseFloat(mapOptions.lng)"
              @load="onMarkerLoad"
            >
              <div>
                <img src="/assets/img/pin_location_partner.svg" />
                <img class="partner-profile" :src="riderInfo.profilePicture" />
              </div>
            </naver-marker>
          </naver-maps>
          <div class="zoom-control">
            <button @click="zoomControl(1)">
              <img src="@/assets/img/order/ic_plus.svg" />
            </button>
            <button @click="zoomControl(-1)">
              <img src="@/assets/img/order/ic_minus.svg" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./layout.css" scoped></style>
<script>
import riderInfoBox from "./riderInfo.vue";
import fetchFail from "./fetchFail.vue";

export default {
  components: { riderInfoBox, fetchFail },
  watch: {},
  data() {
    return {
      map: null,
      mapOptions: {
        lat: "37.52635",
        lng: "126.99156",
        minZoom: 6,
        logoControl: false,
        mapDataControl: false
      },
      initLayers: ["BACKGROUND", "BACKGROUND_DETAIL", "POI_KOREAN"],
      riderInfo: {},
      updatedAt: "",
      fetchLocation: false,
      failCode: null,
      partner: {
        lat: null,
        lng: null
      },
      refreshing: false
    };
  },
  methods: {
    clickMask(event) {
      if (event.target.classList.contains("modal-wrapper")) {
        this.closeModal();
      }
    },
    closeModal() {
      this.$emit("closeModal");
    },

    getMapRegion() {
      const pins = this.pins;
      const partner = [this.partner.lat, this.partner.lng];

      let [minX, maxX, minY, maxY] = [
        pins[0].coords[0],
        pins[0].coords[0],
        pins[0].coords[1],
        pins[0].coords[1]
      ];

      pins.forEach((pin) => {
        minX = Math.min(minX, pin.coords[0]);
        maxX = Math.max(maxX, pin.coords[0]);
        minY = Math.min(minY, pin.coords[1]);
        maxY = Math.max(maxY, pin.coords[1]);
      });

      minX = Math.min(minX, partner[0]);
      maxX = Math.max(maxX, partner[0]);
      minY = Math.min(minY, partner[1]);
      maxY = Math.max(maxY, partner[1]);

      return new naver.maps.LatLngBounds(
        new naver.maps.LatLng(minX, minY),
        new naver.maps.LatLng(maxX, maxY)
      );
    },
    async refresh() {
      this.refreshing = true;
      await this.getRiderLocation();
      this.map.panToBounds(this.getMapRegion());
      this.refreshing = false;
    },

    async getRiderLocation() {
      const location = await this.$store.dispatch(
        "locations/getRiderLocationByOrderId",
        this.orderId
      );
      if (location.success) {
        if (location.code === 200) {
          this.partner.lat = location.coords.lat;
          this.partner.lng = location.coords.long;
          this.mapOptions.lat = this.partner.lat;
          this.mapOptions.lng = this.partner.lng;
          this.riderInfo = location.riderInfo;
          this.updatedAt = location.updatedAt;
          this.fetchLocation = true;
        } else {
          this.failCode = location.code;
          this.fetchLocation = false;
        }
      } else {
        console.log(location.code);
        this.failCode = location.code;
        this.fetchLocation = false;
      }
    },
    //지도 설정
    async onMapLoad(vue) {
      this.map = vue.map;
      this.map.panToBounds(
        this.getMapRegion(),
        { duration: 1000, easing: "easeOutCubic" },
        {
          top: 100,
          right: 100,
          bottom: 100,
          left: 100
        }
      );
    },

    zoomControl(action) {
      const currentZoom = this.map.getZoom();
      this.map.setZoom(currentZoom + action);
    },

    //마커 설정
    onMarkerLoad(vue) {
      const marker = vue.marker;
      const icon = marker.getIcon();
      marker.setZIndex(10);
      vue.marker.setIcon({
        content: icon.content,
        size: new naver.maps.Size(45, 55),
        anchor: new naver.maps.Point(23, 53)
      });
    }
  },
  async created() {
    const vm = this;
    await vm.getRiderLocation();
  },

  props: ["orderId", "pins"]
};
</script>
